<template>
  <div>
    <div id="languages">
      <!--<div class="lang-title">{{la | translate}}</div>-->
      <div class="select-box" style="position: relative">
        <languageOptions v-if="isExpand" @languageChange="languageChange" v-bind:language="language" v-bind:languages="languages"></languageOptions>
      </div>
        <div class="lang-selected" v-if="!settings" @click="changeLang">{{selectedLang | translate}} <div class="arrow-down"></div></div>
      <!--<select v-model="selectedLang">
        <option v-for="lang in languages" :value="lang">{{lang | translate}}</option>
      </select>-->
      <div class="logout" @click="logMeOut" v-if="token && !settings"><img src="/static/images/logout.png" /></div>
      <img src="/static/images/settings-icon.png" @click="checkreLogin" v-if="settings" class="settings-icon"/>
    </div>
    <div class="back-drop" v-if="checkReports">
        </div>
      <div v-if="checkReports" class="reports-login">
        <loginForm class=""
            v-bind:token="token"
            v-bind:userAction='userAction'
            v-bind:errorMsg='errorMsg'
            :buttonName="btnName"
            @checkUser='checkUser'
            @closePopup='closePopup'>
        </loginForm>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import languageOptions from './language-optionGroup'
import loginForm from './login-form'

export default {
  name: 'Languages',
  data () {
    return {
      selectedLang: null,
      la: 'Language',
      lout: 'Logout',
      loadLang: 'load',
      isExpand: false,
      tid: null,
      checkReports: null,
      btnName: 'Continue',
      userAction: '',
      errorMsg: false,
      popupHide: false
    }
  },
  props: ['settings'],
  computed: {
    ...mapGetters([
      'languages',
      'language',
      'token',
      'showReportsPopup'
    ])
  },
  components: {
    loginForm,
    languageOptions
  },
  mounted: function () {
    this.selectedLang = this.language
    document.addEventListener('click', this.documentClick)
    document.addEventListener('touchstart', this.documentClick, false)
    this.tid = this.$route.params.terminalId
    // console.log(this.showReportsPopup)
  },
  methods: {
    ...mapActions([
      'changeLanguage',
      'logOut',
      'reprtsPopupShow',
      'reportsLogin'
    ]),
    logMeOut () {
      localStorage.clear()
      this.logOut()
      // else {
      //   this.$router.push({path: `/`})
      // }
      if (this.tid === 'undefined') {
        this.$router.push({name: 'getTerminalId'})
      } else {
        this.$router.push({path: `/${this.tid}`})
      }
    },
    closePopup () {
      this.checkReports = false
      clearTimeout(this.popupHide)
    },
    checkreLogin () {
      this.checkReports = true
      this.popupHide = setTimeout(() => {
        this.closePopup()
      }, (1000 * 60 * 2))
    },
    checkUser (a) {
      let loginId = a.loginId
      let password = a.password
      let vm = this
      this.reportsLogin({loginId, password}).then((res) => {
        if (res.status === 'Success') {
          // this.reprtsPopupHide()
          this.$router.push({path: `/${this.tid}/home`})
          // this.$router.push({name: 'Reports'})
        }
      }).catch(error => {
        vm.errorMsg = error.error
        setTimeout(() => {
          vm.errorMsg = false
        }, 3000)
      })
    },
    goToHome () {
      // this.reprtsPopupShow()
      this.$router.push({path: `/${this.tid}`})
    },
    changeLang () {
      this.isExpand = true
    },
    languageChange (a) {
      this.selectedLang = a
      this.isExpand = false
      this.changeLanguage(a)
    },
    documentClick (e) {
      // debugger
      let cn = e.target
      // let cn = document.getElementById('user-section')
      let closestDiv = cn.closest('.lang-selected')
      if (closestDiv !== null && closestDiv !== undefined) {
        this.isExpand = true
      } else {
        this.isExpand = false
      }
    }
  }
}
</script>

<style scoped>
  #languages {
    list-style: none;
    list-style: none;
    margin: 0px;
    padding: 0px;
    display: flex;
    position: absolute;
    top: 10px;
    z-index: 5;
    align-items: center;
    justify-content: center;
  }
  div[dir='rtl'] #languages {
    left: 0px;
    margin-left: 30px;
  }
  div[dir='ltr'] #languages {
    right: 0px;
    margin-right: 3px;
  }
  .language {
    margin: 5px;
  }
  .language > button {
    border: none;
    height: 20px;
    color: #333;
    cursor: pointer;
    background-color: #FFF;
  }
  .language > button.active {
    background-color: #880913;
    color: #FFF;
  }
  .logout {
    border: none;
    color: #333;
    cursor: pointer;
    margin: 0px 10px;
    display: flex;
    height: 20px;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    font-size: 12px;
  }
  .logout img {
    width: 80%;
  }
  .lang-title {
    color: #FFF;
    margin-right: 5px;
  }
  select {
    height: 30px;
  }
  .lang-selected {
    width: 100px;
    /* background-color: #ff971c; */
    color: #000;
    display: flex;
    align-items: center;
    height: 30px;
    padding: 10px;
    justify-content: space-between;
    cursor: pointer;
  }
  .lang-selected:hover {
    /* background-color: #333; */
  }
.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #000;
}
.settings-icon {
  margin-top: 22px;
  margin-right: 45px;
  cursor: pointer;
  display: none;
}
div[dir='rtl'] .settings-icon {
  margin-right: 0;
}
.reports-login {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto auto;
  z-index: 11;
  max-width: 365px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 450px;
}
@media only screen and (min-width: 2000px) {
  #languages {
    height: 100px;
    margin-top: 3%;
  }
  .logout {
    height: 100%;
  }
  .logout img {
    width: 120px;
  }
  div[dir='ltr'] #languages {
    margin-right: 5%;
  }
  .lang-selected {
    margin-right: 10%;
    width: 500px;
    font-size: 80px;
    height: 120px;
    padding: 2%;
  }
  .arrow-down {
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-top: 25px solid #FFF;
  }
  .settings-icon {
    width: 140px;
    margin-right: 0;
  }

  div[dir='rtl'] #languages {
    margin-left: 5%;
  }
  div[dir='rtl'] .lang-selected {
    margin-left: 50px;
  }
  .reports-login {
    top: 30%;
    bottom: initial;
    max-height: initial !important;
    max-width: 45vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Languages.vue